export const VNDC_ABI = [
  {
    type: 'constructor',
    stateMutability: 'nonpayable',
    inputs: [
      { type: 'address', name: '_router', internalType: 'address' },
      { type: 'uint256', name: '_minAmountMint', internalType: 'uint256' },
      { type: 'uint256', name: '_feeWithdraw', internalType: 'uint256' },
      { type: 'uint256', name: '_bonus', internalType: 'uint256' },
      { type: 'uint256', name: '_minPriceMint', internalType: 'uint256' },
      { type: 'uint256', name: '_maxPriceRedeem', internalType: 'uint256' },
    ],
  },
  {
    type: 'event',
    name: 'Approval',
    inputs: [
      { type: 'address', name: 'owner', internalType: 'address', indexed: true },
      { type: 'address', name: 'spender', internalType: 'address', indexed: true },
      { type: 'uint256', name: 'value', internalType: 'uint256', indexed: false },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'EventAddWhitelist',
    inputs: [
      { type: 'address[]', name: '_whitelist', internalType: 'address[]', indexed: false },
      { type: 'bool', name: '_mintable', internalType: 'bool', indexed: false },
      { type: 'bool', name: '_redeemable', internalType: 'bool', indexed: false },
      { type: 'uint256', name: '_mintMax', internalType: 'uint256', indexed: false },
      { type: 'address', name: '_currency', internalType: 'address', indexed: false },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'EventMintWhitelist',
    inputs: [
      { type: 'address', name: 'to', internalType: 'address', indexed: true },
      { type: 'uint256', name: 'amount', internalType: 'uint256', indexed: false },
      { type: 'address', name: 'currency', internalType: 'address', indexed: true },
      { type: 'uint256', name: 'amountsOut', internalType: 'uint256', indexed: false },
      { type: 'uint256', name: 'liquidity', internalType: 'uint256', indexed: false },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'EventWithdrawWhitelist',
    inputs: [
      { type: 'address', name: 'to', internalType: 'address', indexed: true },
      { type: 'uint256', name: 'amountLiquidty', internalType: 'uint256', indexed: false },
      { type: 'address', name: 'currency', internalType: 'address', indexed: true },
      { type: 'uint256', name: 'amountAWithdraw', internalType: 'uint256', indexed: false },
      { type: 'uint256', name: 'amountBWithdraw', internalType: 'uint256', indexed: false },
      { type: 'uint256', name: 'feeWithdraw', internalType: 'uint256', indexed: false },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'OwnershipTransferred',
    inputs: [
      { type: 'address', name: 'previousOwner', internalType: 'address', indexed: true },
      { type: 'address', name: 'newOwner', internalType: 'address', indexed: true },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'Paused',
    inputs: [{ type: 'address', name: 'account', internalType: 'address', indexed: false }],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'Transfer',
    inputs: [
      { type: 'address', name: 'from', internalType: 'address', indexed: true },
      { type: 'address', name: 'to', internalType: 'address', indexed: true },
      { type: 'uint256', name: 'value', internalType: 'uint256', indexed: false },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'Unpaused',
    inputs: [{ type: 'address', name: 'account', internalType: 'address', indexed: false }],
    anonymous: false,
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [{ type: 'uint256', name: '', internalType: 'uint256' }],
    name: 'BASE_RATE',
    inputs: [],
  },
  {
    type: 'function',
    stateMutability: 'nonpayable',
    outputs: [],
    name: 'addAdmin',
    inputs: [
      { type: 'address[]', name: '_admins', internalType: 'address[]' },
      { type: 'bool', name: '_isBool', internalType: 'bool' },
    ],
  },
  {
    type: 'function',
    stateMutability: 'nonpayable',
    outputs: [],
    name: 'addWhitelist',
    inputs: [
      { type: 'address[]', name: '_whitelist', internalType: 'address[]' },
      { type: 'bool', name: '_mintable', internalType: 'bool' },
      { type: 'bool', name: '_redeemable', internalType: 'bool' },
      { type: 'uint256', name: '_mintMax', internalType: 'uint256' },
      { type: 'address', name: '_currency', internalType: 'address' },
    ],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [{ type: 'bool', name: '', internalType: 'bool' }],
    name: 'adminMap',
    inputs: [{ type: 'address', name: '', internalType: 'address' }],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [{ type: 'uint256', name: '', internalType: 'uint256' }],
    name: 'allowance',
    inputs: [
      { type: 'address', name: 'owner', internalType: 'address' },
      { type: 'address', name: 'spender', internalType: 'address' },
    ],
  },
  {
    type: 'function',
    stateMutability: 'nonpayable',
    outputs: [{ type: 'bool', name: '', internalType: 'bool' }],
    name: 'approve',
    inputs: [
      { type: 'address', name: 'spender', internalType: 'address' },
      { type: 'uint256', name: 'amount', internalType: 'uint256' },
    ],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [{ type: 'uint256', name: '', internalType: 'uint256' }],
    name: 'balanceOf',
    inputs: [{ type: 'address', name: 'account', internalType: 'address' }],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [{ type: 'uint256', name: '', internalType: 'uint256' }],
    name: 'bonus',
    inputs: [],
  },
  {
    type: 'function',
    stateMutability: 'nonpayable',
    outputs: [],
    name: 'burn',
    inputs: [{ type: 'uint256', name: 'amount', internalType: 'uint256' }],
  },
  {
    type: 'function',
    stateMutability: 'nonpayable',
    outputs: [],
    name: 'burnFrom',
    inputs: [
      { type: 'address', name: 'account', internalType: 'address' },
      { type: 'uint256', name: 'amount', internalType: 'uint256' },
    ],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [{ type: 'bool', name: '', internalType: 'bool' }],
    name: 'currencyList',
    inputs: [{ type: 'address', name: '', internalType: 'address' }],
  },
  {
    type: 'function',
    stateMutability: 'pure',
    outputs: [{ type: 'uint8', name: '', internalType: 'uint8' }],
    name: 'decimals',
    inputs: [],
  },
  {
    type: 'function',
    stateMutability: 'nonpayable',
    outputs: [{ type: 'bool', name: '', internalType: 'bool' }],
    name: 'decreaseAllowance',
    inputs: [
      { type: 'address', name: 'spender', internalType: 'address' },
      { type: 'uint256', name: 'subtractedValue', internalType: 'uint256' },
    ],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [
      { type: 'uint256', name: 'VNDCAmount', internalType: 'uint256' },
      { type: 'uint256', name: 'currencyAmount', internalType: 'uint256' },
    ],
    name: 'estimateAmountByLp',
    inputs: [
      { type: 'address', name: '_currency', internalType: 'address' },
      { type: 'uint256', name: 'lpAmount', internalType: 'uint256' },
    ],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [{ type: 'uint256', name: '', internalType: 'uint256' }],
    name: 'feeWithdraw',
    inputs: [],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [{ type: 'uint256', name: 'liquidityAmount', internalType: 'uint256' }],
    name: 'getAmountLiquidity',
    inputs: [
      { type: 'uint256', name: 'VNDCAmount', internalType: 'uint256' },
      { type: 'address', name: 'user', internalType: 'address' },
      { type: 'address', name: 'currency', internalType: 'address' },
    ],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [{ type: 'uint256', name: '', internalType: 'uint256' }],
    name: 'getNumberOfUsers',
    inputs: [{ type: 'address', name: '_currency', internalType: 'address' }],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [{ type: 'uint256', name: '', internalType: 'uint256' }],
    name: 'getPriceInputToken',
    inputs: [
      { type: 'uint256', name: '_amount', internalType: 'uint256' },
      { type: 'address', name: '_currency', internalType: 'address' },
    ],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [{ type: 'uint256', name: '', internalType: 'uint256' }],
    name: 'getPriceInputVNDC',
    inputs: [
      { type: 'uint256', name: '_amountVNDC', internalType: 'uint256' },
      { type: 'address', name: '_currency', internalType: 'address' },
    ],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [
      { type: 'uint256', name: 'VNDCReserve', internalType: 'uint256' },
      { type: 'uint256', name: 'currencyReserve', internalType: 'uint256' },
    ],
    name: 'getReserve',
    inputs: [{ type: 'address', name: '_currency', internalType: 'address' }],
  },
  {
    type: 'function',
    stateMutability: 'nonpayable',
    outputs: [{ type: 'bool', name: '', internalType: 'bool' }],
    name: 'increaseAllowance',
    inputs: [
      { type: 'address', name: 'spender', internalType: 'address' },
      { type: 'uint256', name: 'addedValue', internalType: 'uint256' },
    ],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [{ type: 'bool', name: '', internalType: 'bool' }],
    name: 'isAfterMintTime',
    inputs: [{ type: 'uint256', name: 'timestamp', internalType: 'uint256' }],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [{ type: 'address', name: '', internalType: 'contract IPancakePair' }],
    name: 'lpPairMap',
    inputs: [{ type: 'address', name: '', internalType: 'address' }],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [{ type: 'uint256', name: '', internalType: 'uint256' }],
    name: 'lpPerUser',
    inputs: [
      { type: 'address', name: '', internalType: 'address' },
      { type: 'address', name: '', internalType: 'address' },
    ],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [{ type: 'uint256', name: '', internalType: 'uint256' }],
    name: 'minAmountMint',
    inputs: [],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [
      { type: 'uint256', name: 'minPriceMint', internalType: 'uint256' },
      { type: 'uint256', name: 'maxPriceRedeem', internalType: 'uint256' },
      { type: 'uint256', name: 'minSeconds', internalType: 'uint256' },
    ],
    name: 'minMaxSetting',
    inputs: [],
  },
  {
    type: 'function',
    stateMutability: 'nonpayable',
    outputs: [],
    name: 'mintWhitelist',
    inputs: [
      { type: 'uint256', name: '_amount', internalType: 'uint256' },
      { type: 'address', name: '_currency', internalType: 'address' },
      { type: 'uint256', name: 'slippage', internalType: 'uint256' },
    ],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [{ type: 'string', name: '', internalType: 'string' }],
    name: 'name',
    inputs: [],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [{ type: 'address', name: '', internalType: 'address' }],
    name: 'owner',
    inputs: [],
  },
  { type: 'function', stateMutability: 'nonpayable', outputs: [], name: 'pause', inputs: [] },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [{ type: 'bool', name: '', internalType: 'bool' }],
    name: 'paused',
    inputs: [],
  },
  { type: 'function', stateMutability: 'nonpayable', outputs: [], name: 'renounceOwnership', inputs: [] },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [{ type: 'address', name: '', internalType: 'contract IPancakeRouter' }],
    name: 'router',
    inputs: [],
  },
  {
    type: 'function',
    stateMutability: 'nonpayable',
    outputs: [],
    name: 'setBonus',
    inputs: [{ type: 'uint256', name: '_bonus', internalType: 'uint256' }],
  },
  {
    type: 'function',
    stateMutability: 'nonpayable',
    outputs: [],
    name: 'setCurrencyList',
    inputs: [
      { type: 'address[]', name: '_currencyList', internalType: 'address[]' },
      { type: 'bool', name: '_isBool', internalType: 'bool' },
    ],
  },
  {
    type: 'function',
    stateMutability: 'nonpayable',
    outputs: [],
    name: 'setFeeWithdraw',
    inputs: [{ type: 'uint256', name: '_feeWithdraw', internalType: 'uint256' }],
  },
  {
    type: 'function',
    stateMutability: 'nonpayable',
    outputs: [],
    name: 'setLpPair',
    inputs: [
      { type: 'address', name: '_currency', internalType: 'address' },
      { type: 'address', name: '_lpPair', internalType: 'address' },
    ],
  },
  {
    type: 'function',
    stateMutability: 'nonpayable',
    outputs: [],
    name: 'setMaxPriceRedeem',
    inputs: [{ type: 'uint256', name: '_maxPriceRedeem', internalType: 'uint256' }],
  },
  {
    type: 'function',
    stateMutability: 'nonpayable',
    outputs: [],
    name: 'setMinAmountMint',
    inputs: [{ type: 'uint256', name: '_minAmountMint', internalType: 'uint256' }],
  },
  {
    type: 'function',
    stateMutability: 'nonpayable',
    outputs: [],
    name: 'setMinPriceMint',
    inputs: [{ type: 'uint256', name: '_minPriceMint', internalType: 'uint256' }],
  },
  {
    type: 'function',
    stateMutability: 'nonpayable',
    outputs: [],
    name: 'setMinSeconds',
    inputs: [{ type: 'uint256', name: '_minSeconds', internalType: 'uint256' }],
  },
  {
    type: 'function',
    stateMutability: 'nonpayable',
    outputs: [],
    name: 'setRouter',
    inputs: [{ type: 'address', name: '_router', internalType: 'address' }],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [{ type: 'string', name: '', internalType: 'string' }],
    name: 'symbol',
    inputs: [],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [{ type: 'uint256', name: '', internalType: 'uint256' }],
    name: 'totalSupply',
    inputs: [],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [{ type: 'uint256', name: '', internalType: 'uint256' }],
    name: 'totalTokenPerUserMap',
    inputs: [
      { type: 'address', name: '', internalType: 'address' },
      { type: 'address', name: '', internalType: 'address' },
    ],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [{ type: 'uint256', name: '', internalType: 'uint256' }],
    name: 'totalVNDCPerUserMap',
    inputs: [
      { type: 'address', name: '', internalType: 'address' },
      { type: 'address', name: '', internalType: 'address' },
    ],
  },
  {
    type: 'function',
    stateMutability: 'nonpayable',
    outputs: [{ type: 'bool', name: '', internalType: 'bool' }],
    name: 'transfer',
    inputs: [
      { type: 'address', name: 'to', internalType: 'address' },
      { type: 'uint256', name: 'amount', internalType: 'uint256' },
    ],
  },
  {
    type: 'function',
    stateMutability: 'nonpayable',
    outputs: [{ type: 'bool', name: '', internalType: 'bool' }],
    name: 'transferFrom',
    inputs: [
      { type: 'address', name: 'from', internalType: 'address' },
      { type: 'address', name: 'to', internalType: 'address' },
      { type: 'uint256', name: 'amount', internalType: 'uint256' },
    ],
  },
  {
    type: 'function',
    stateMutability: 'nonpayable',
    outputs: [],
    name: 'transferOwnership',
    inputs: [{ type: 'address', name: 'newOwner', internalType: 'address' }],
  },
  { type: 'function', stateMutability: 'nonpayable', outputs: [], name: 'unpause', inputs: [] },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [{ type: 'address', name: '', internalType: 'address' }],
    name: 'users',
    inputs: [
      { type: 'address', name: '', internalType: 'address' },
      { type: 'uint256', name: '', internalType: 'uint256' },
    ],
  },
  {
    type: 'function',
    stateMutability: 'view',
    outputs: [
      { type: 'uint256', name: 'mintMax', internalType: 'uint256' },
      { type: 'bool', name: 'mintable', internalType: 'bool' },
      { type: 'bool', name: 'redeemable', internalType: 'bool' },
      { type: 'uint256', name: 'lastMintTimestamp', internalType: 'uint256' },
      { type: 'bool', name: 'active', internalType: 'bool' },
    ],
    name: 'whitelistMap',
    inputs: [
      { type: 'address', name: '', internalType: 'address' },
      { type: 'address', name: '', internalType: 'address' },
    ],
  },
  {
    type: 'function',
    stateMutability: 'nonpayable',
    outputs: [],
    name: 'withdrawEmergency',
    inputs: [
      { type: 'address', name: '_token', internalType: 'address' },
      { type: 'uint256', name: '_amount', internalType: 'uint256' },
    ],
  },
  {
    type: 'function',
    stateMutability: 'nonpayable',
    outputs: [],
    name: 'withdrawWhitelist',
    inputs: [
      { type: 'uint256', name: '_amountVNDC', internalType: 'uint256' },
      { type: 'address', name: '_currency', internalType: 'address' },
      { type: 'uint256', name: '_slippage', internalType: 'uint256' },
    ],
  },
] as const
